// API Constants
export const API_ENDPOINTS = {
  BASE_URL: 'https://crm.havalimanitaksi.com.tr',
  WEBSERVICE: 'https://crm.havalimanitaksi.com.tr/webservice.php',
  PAYMENT_PROCESS: '/odemephp/process_payment.php',
  PAYMENT_SUCCESS: '/odemephp/success.php',
  PAYMENT_FAIL: '/odemephp/fail.php'
};

// Default headers for API requests
export const API_HEADERS = {
  'Content-Type': 'application/json; charset=UTF-8'
};

// API Methods
export const API_METHODS = {
  CHECK_USER: 'checkUser',
  VERIFY_SMS: 'verifySms',
  GET_BORCLAR: 'getBorclar',
  GET_SEPET: 'getSepet',
  CREATE_SEPET: 'createSepet',
  REMOVE_SEPET: 'removeSepet',
  CONFIRM_PAYMENT: 'confirmPayment',
  GET_ARAC_BILGILERI: 'getAracBilgileri',
  GET_TAHSILATLAR: 'getTahsilatlar',
  LOGIN: 'login',
  GET_YAKIT_HAREKETLERI: 'getYakitHareketleri',
  GET_PLAKA_GECISLERI: 'getPlakaGecisleri'
}; 